<template>
  <div>
    <label v-if="companyEnabled" class="is-required">
      {{ companyText || 'Partner Name' }}
      <input
        data-hj-allow
        type="text"
        placeholder="Acme, Inc"
        v-model="invite.data.agencyName"
        @input="emitInviteChange"
        required
      />
    </label>
    <label class="is-required">
      Name
      <input
        data-hj-allow
        type="text"
        placeholder="John Doe"
        v-model="invite.data.name"
        @input="emitInviteChange"
        required
      />
    </label>
    <label class="is-required">
      Email
      <input
        type="email"
        placeholder="jdoe@example.com"
        v-model="invite.data.email"
        @input="emitInviteChange"
        required
      />
    </label>
    <hr class="mb-lg" />
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    companyText: String,
    companyEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      invite: {
        data: {
          name: '',
          email: '',
          agencyName: '',
        },
        key: this.index,
      },
    };
  },
  methods: {
    emitInviteChange() {
      let payload = this.invite;

      if (!this.companyEnabled) {
        delete payload.data.agencyName;
      }

      return this.$emit('invite-change', payload);
    },
  },
};
</script>
